import { Routes, Route, BrowserRouter } from "react-router-dom";
import "./App.less";
import LandingPageWrapper from "./pages/landing-page-wrapper/landing-page-wrapper";
import SystemCheck from "./pages/system-check/system-check";
import AppContextProvider from "./providers/app-context-provider";
import { Locations } from "./lib/locations";
import ExamSystemCheck from "./pages/system-check/exam-system-check";

function App() {
  return (
    <AppContextProvider>
      <BrowserRouter>
        <div className="app">
          <Routes>
            <Route path="/" element={<LandingPageWrapper />} />
            <Route path={Locations.systemCheck} element={<SystemCheck />} />
            <Route path={Locations.examSystemCheck} element={<ExamSystemCheck />} />
          </Routes>
        </div>
      </BrowserRouter>
    </AppContextProvider>
  );
}

export default App;
